export default {
    isLoading: state => {
        return state.loading
    },
    isLoadingMore: state => {
        return state.loadingMore
    },
    isSaving: state => {
        return state.saving
    },
    /**
     * Items for ResourceList: when favourites-only is on, exclude variants the user has
     * unfavourited so the grid stays tight (no empty cells).
     */
    resourceListItems: (state) => {
        if (! state.filterState.miscFilters.favourites) {
            return state.data
        }
        return state.data.filter(
            (item) => item.is_customer_favourite === true
        )
    },
}
